;(function() {
  'use strict'

  angular.module('core.imageinput', [])
})()
